import React, {useEffect, useRef, useState} from "react";
import {
  allColumnss,
  itemsInputFieldd as inputFieldsInit,
} from "./TextAway.config";
import {useAppDispatch, useAppSelector} from "../../../../../../redux/hooks";
import {ColumnProps} from "../../../../../../types/models";
import {
  ColumnPopoverDisplay,
  ExpandSearch,
  InputFields,
  ListActionButton,
  Search,
} from "../../../../../../components/common";
import {
  Button,
  Col,
  Form,
  message,
  Popover,
  Row,
  Space,
  Table,
  Typography,
} from "antd";
import "./styles.scss";
import Icons from "../../../../../../assets/icons";
import {ExcelSVG, RefreshIconSVG} from "../../../../../../assets";
import {
  searchRecruiment,
  setDetailDoc,
} from "../../../../../../redux/reducer/employee";
import {employeeService} from "api";
import ModalCustom from "../../../../../../components/common/ModalCustom/ModalCustom";
import FormAdd from "./FormAdd/FormAdd";
import Notification from "../../../../../../components/common/notification/notification";
import axiosClient from "../../../../../../api/_";
import {
  generateFileName,
  saveTableOptions,
  getTableOptions,
  formatDateToString,
} from "../../../../../../helper/common";
import {RangePickerProps} from "antd/es/date-picker";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import {SearchOutlined} from "@ant-design/icons";
import {data} from "data/env";
import {setButtonsHeader} from "redux/reducer/common";
import {FORMAT_TIME} from "types/enums";
const TextArray = () => {
  const [form] = Form.useForm();
  const modalRef = useRef<any>();
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState<any[]>([]);
  const [searchValues, setSearchValues] = useState<any>({});
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 10,
  });
  const [loading, setLoading] = useState(false);
  let savedTableOption = getTableOptions(
    "TEXTAWAY_TABLE",
    localStorage.getItem("username")
  );
  const defaultColumns = savedTableOption
    ? allColumnss.map(cl => {
        if (savedTableOption.some(it => it.dataIndex === cl.dataIndex)) {
          let tmp = savedTableOption.find(it => it.dataIndex === cl.dataIndex);
          return {
            ...cl,
            show: true,
            width: tmp?.width ?? null,
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : allColumnss;
  const [columns, setColumns] = useState<any>(
    defaultColumns.filter(e => e.show == true)
  );
  columns.map(e => {
    if (e.key == "index") {
      e.render = (text, record, index) => {
        const rowNumber = (currentPage - 1) * params.limit + index + 1;
        return rowNumber;
      };
    }
  });
  const [paramss, setParamss] = useState<any>({});
  const employees = useAppSelector(state => state.employeesReducer);
  const [type, setType] = useState("");
  const [record, setRecord] = useState(null);
  const dispatch = useAppDispatch();
  const expandRef = useRef<any>();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const onClickSearch = async () => {
    setCurrentPage(1);
    // var searchFields = expandRef?.current?.getData();
    // setParams({ ...params, ...searchFields, page: 1 }); // Đặt trang về 1 khi thực hiện tìm kiếm
    const formValue = expandRef?.current?.getData();
    const searchFields = {
      ...formValue,
      tuNgay: formatDateToString(formValue.tuNgay, FORMAT_TIME.timeDetail),
      denNgay: formatDateToString(formValue.denNgay, FORMAT_TIME.timeDetail),
      //  end: formatDateToString(formValue.end, FORMAT_TIME.dayFull),
    };
    setParams({...formValue, ...params, ...searchFields, page: 1});
  };
  const getList = async (page = 1, limit = 1000) => {
    setLoading(true);
    try {
      //const params = { page, limit};
      const response = await employeeService.getListTextAway({
        ...params,
        ...form.getFieldsValue(),
      });
      setData(response.items);
      setLoading(false);
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi load danh sách văn bản đi");
      setLoading(false);
    }
  };
  const handleSave = (row: any) => {
    const newData = [...data];
    const index = newData.findIndex(item => row.id === item.id);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setData(newData);
  };
  useEffect(() => {
    dispatch(setButtonsHeader([]));
  }, []);
  useEffect(() => {
    getList({
      ...params,
    });
  }, [params]);

  const setShowColumnsList = showColumns => {
    saveTableOptions(
      "TEXTAWAY_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };
  const setShowColumns = (showColumns: React.SetStateAction<ColumnProps[]>) => {
    setColumns(showColumns);
  };
  const onChangePagination = (currentPage, pageSize) => {
    setCurrentPage(currentPage);
    setParams({...params, page: currentPage, limit: pageSize});
  };
  const onClickExportAway = async () => {
    var searchFields = expandRef?.current?.getData();
    setParamss({...paramss, ...searchFields});
    handleExportExcelAway();
  };

  const handleExportExcelAway = async () => {
    setLoading(true);
    try {
      const response = await employeeService
        .getExportTextAway(params)
        .then(res => {
          // console.log("res export", res);
          var link = document.createElement("a");
          const url = window.URL.createObjectURL(res.data);
          link.href = url;
          link.download = `Danh sách văn bản đi.xlsx`;
          link.click();
          setLoading(false);
          Notification("success", "Đã xuất file báo cáo");
        });
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi xảy ra khi xuất file báo cáo");
    }
  };

  const onKeyDown = e => {
    if (e.key === "Enter") {
      onClickSearch();
    }
  };
  const deleteTextAway = async id => {
    try {
      const res = await employeeService.deleteTextAway(id);
      Notification("success", "Đã xóa dữ liệu vừa chọn");
      getList(params);
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi khi xóa dữ liệu");
    }
  };
  const [fields, setFields] = useState<any[]>(inputFieldsInit);
  useEffect(() => {
    const disabledDateStart: RangePickerProps["disabledDate"] = currentDate => {
      const endDay = form.getFieldValue("denNgay");
      if (endDay) {
        return currentDate > endDay;
      }
    };
    const disabledDateEnd: RangePickerProps["disabledDate"] = currentDate => {
      const start = form.getFieldValue("tuNgay");
      if (start) {
        return currentDate < start;
      }
    };
    inputFieldsInit.find(e => e.name == "tuNgay").disabledDate =
      disabledDateStart;
    inputFieldsInit.find(e => e.name == "denNgay").disabledDate =
      disabledDateEnd;
    setFields([...inputFieldsInit]);
  }, []);
  useEffect(() => {
    const newColumns = columns;
    columns.find(e => e.dataIndex == "action").render = (
      value,
      _record,
      index
    ) => {
      return (
        <ListActionButton
          deleteFunction={() => {
            deleteTextAway(_record.id);
            //
            // ;
          }}
          editFunction={() => {
            setType("Sửa");
            dispatch(setDetailDoc(_record));
            modalRef.current?.openModal();
          }}
        ></ListActionButton>
      );
    };

    setColumns(newColumns);
  }, []);
  // Xác định độ dài của mảng columns
  const numberOfColumns = columns.length;

  // Thiết lập giá trị scroll dựa vào số lượng cột
  let scrollX;
  if (numberOfColumns <= 4) {
    scrollX = 1000;
  } else {
    scrollX = 2000;
  }
  return (
    <div className="recruitment-list" onKeyDown={onKeyDown} tabIndex={0}>
      <div className="recruitment-container">
        <div className="container">
          {fields && (
            <ExpandSearch
              ref={expandRef}
              fields={fields}
              onClickSearch={onClickSearch}
              // Ẩn nút "Tìm kiếm nâng cao"
              isSearchExpend={false}
              // isResetField={false}
            />
          )}
          {/* <Form form={form} onKeyDown={onKeyDown} tabIndex={0}>
            <Row gutter={[16, 8]}>
              {fields && <InputFields data={fields} />}
            </Row>
            <Row justify={"end"} style={{marginTop: 8}}>
              <Space>
                <Button
                ref={expandRef}
                  type="ghost"
                  className="btn-sub"
                  icon={<Icons.reload rev={0} />}
                  onClick={() => {
                    form.resetFields();
                    onClickSearch();
                  }}
                >
                  Xoá tìm kiếm
                </Button>
                <Button
                  icon={<Icons.search rev={0} />}
                  ref={expandRef}
                  type="primary"
                  onClick={onClickSearch}
                >
                  Tìm kiếm
                </Button>
              </Space>
            </Row>
          </Form> */}
        </div>
        <div className="container">
          <Space style={{width: "100%"}} direction="vertical">
            <Row justify={"space-between"} gutter={[16, 8]}>
              <Col>
                <Popover
                  trigger="click"
                  placement="topLeft"
                  content={
                    <ColumnPopoverDisplay
                      setShowColumns={setShowColumns}
                      columns={columns}
                      width={"400px"}
                    ></ColumnPopoverDisplay>
                  }
                >
                  <Button icon={<Icons.bars />} className="btn-sub">
                    Cột hiển thị
                  </Button>
                </Popover>
              </Col>
              <Col>
                <Space style={{width: "100%"}}>
                  <Button
                    className="custom-btn"
                    type="default"
                    onClick={onClickExportAway}
                    icon={<ExcelSVG />}
                  >
                    <Typography>Xuất báo cáo</Typography>
                  </Button>
                  <Button
                    type="primary"
                    onClick={() => {
                      setType("Thêm mới");
                      dispatch(setDetailDoc(null));
                      modalRef.current?.openModal();
                    }}
                  >
                    Thêm mới
                  </Button>
                </Space>
              </Col>
            </Row>
            {data && (
              <CustomResizableTable
                // rowSelection={{
                //   type: "radio",
                //   ...rowSelection,
                // }}
                setShowColumns={setShowColumnsList}
                pagination={{
                  position: ["bottomRight"],
                  showSizeChanger: true,
                  total: employees.RecruimentTotal,
                  onChange: onChangePagination,
                  current: currentPage,
                }}
                onRow={(record, rowIndex) => {
                  return {
                    // onDoubleClick: e => handleView(record.id),
                  };
                }}
                rowKey={record => record.id}
                columns={columns}
                dataSource={data}
                bordered={true}
                loading={loading}
                // scroll={{ x: scrollX  }}
              />
            )}
            <ModalCustom
              ref={modalRef}
              width={1600}
              title={`${type} văn bản đi`}
              centered
            >
              <FormAdd
                setData={setRecord}
                data={record}
                getListApi={getList}
                type={type}
                setCurrentPage={null}
              ></FormAdd>
            </ModalCustom>
          </Space>
        </div>
      </div>
    </div>
  );
};

export default TextArray;
